import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Tag, Button, Input, Icon } from 'antd';
import EditIcon from '@material-ui/icons/Edit';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';

const { Title } = Typography;

@inject('stockStore')
@observer
class OutOfStockList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    updateStockButtonOnClick = taskId => {
        this.props.stockStore.setTaskId(taskId);
        this.props.stockStore.initUpdate();
        this.props.stockStore.setShowUpdateStockModal(true);
    }

    // TABLE SETTINGS

    getColumns = () => {
        return [
            {
                title: 'Item',
                dataIndex: 'taskName',
                key: 'taskName',
                ...this.getColumnSearchProps('taskName')
            },
            {
                title: 'Categories',
                key: 'parentName',
                dataIndex: 'parentName',
                render: parentName => (
                    <span>
                        <Tag color={'green'}>
                            {parentName}
                        </Tag>
                    </span>
                ),
            },
            {
                title: 'Minimum Stock',
                dataIndex: 'minimumStock',
                key: 'minimumStock'
            },
            {
                title: 'Current Stock',
                dataIndex: 'total',
                key: 'total'
            },
            {
                title: 'Action',
                dataIndex: 'taskID',
                key: 'action',
                render: taskID => (
                    <span>
                        <Button onClick={() => this.updateStockButtonOnClick(taskID)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none' }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    })

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        })
    }

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { outOfStocks } = this.props.stockStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <Title level={3}>Out Of Stock List</Title>
                    <Table columns={this.getColumns()} dataSource={outOfStocks} />
                </Form>
            </React.Fragment>
        )
    }
}

export default OutOfStockList